import React from 'react';
import type { Breakpoint } from '../../config/uiSizes';

const getBreakpoint = (): Breakpoint => {
  if (typeof window === 'undefined') return 'xl';
  const w = window.innerWidth;
  if (w >= 1536) return '2xl';
  if (w >= 1280) return 'xl';
  if (w >= 1024) return 'lg';
  return 'md';
};

/**
 * Reactively tracks the current Tailwind breakpoint.
 * Updates automatically when the window is resized across a breakpoint boundary.
 */
const useBreakpoint = (): Breakpoint => {
  const [bp, setBp] = React.useState<Breakpoint>(getBreakpoint);

  React.useEffect(() => {
    const update = () => setBp(getBreakpoint());

    const mqls: MediaQueryList[] = [
      window.matchMedia('(min-width: 1536px)'),
      window.matchMedia('(min-width: 1280px)'),
      window.matchMedia('(min-width: 1024px)'),
    ];

    mqls.forEach((mql) => mql.addEventListener('change', update));
    return () => mqls.forEach((mql) => mql.removeEventListener('change', update));
  }, []);

  return bp;
};

export default useBreakpoint;
